import { IResponseProcessor } from "..";
import { IOrderDetailResult } from "../document/DocumentsApi";
import { ISalesData } from "../manufacturer/ManufacturersApi";
import { IOpportunity } from "../opportunity/OpportunitiesApi";
import { IReturn } from "../return/ReturnsApi";
import { IManufacturerBid } from "../search/SearchApi";

export default class ResellersApi {
  constructor(
    private _baseUrl: string,
    private _getToken: (applicationId: string) => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'ResellersApi' class is in use. Please migrate to RTK Query hooks as outlined in CONTRIBUTING.md."
    );
  }

  async retrieveReseller(applicationId: string, resellerId: string, withSpecification: boolean): Promise<IResellerInfo> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Reseller/${resellerId}?withSpecification=${withSpecification}`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    const info: IResellerInfo = await res.json();

    return info;
  }

  async retrieveResellers(applicationId: string): Promise<IResellerInfo[]> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Resellers`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    const info: IResellerInfo[] = await res.json();

    return info;
  }

  async insertQualificationId(applicationId: string, resellerId: string, qualificationId: string): Promise<boolean> {

    const res = await fetch(`${this._baseUrl}/${applicationId}/Reseller/${resellerId}/Qualification?newValue=${encodeURIComponent(qualificationId)}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }

  async removeQualificationId(applicationId: string, resellerId: string): Promise<boolean> {

    const res = await fetch(`${this._baseUrl}/${applicationId}/Reseller/${resellerId}/Qualification`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }

  async getResellerSalesStatistics(applicationId: string, resellerId: string, startDate?: string, endDate?: string): Promise<ISalesStatistics[]> {
    const url = new URL(`${this._baseUrl}/${applicationId}/Reseller/${resellerId}/SalesStatistics`);
    if (startDate) {
      url.searchParams.append("startDate", startDate);
    }
    if (endDate) {
      url.searchParams.append("endDate", endDate);
    }

    const res = await fetch(url.toString(), {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    const stats: ISalesStatistics[] = await res.json();

    return stats;
  }
}

export interface IResellerInfo {
  AREmail: string;
  Address1: string;
  Address2: string;
  AutoUpdate: boolean;
  City: string;
  ContactName: string;
  Country: string;
  CreationDate: number;
  LastInvoiceDate: number;
  CreditLimit: number;
  DefaultLeadTime: string;
  DefaultMaxInventoryValue: string;
  DefaultMinimumOrder: string;
  DefaultWeeksOfStocking: string;
  Domain: string;
  GoogleEmail: string;
  ResellerId: string;
  Name: string;
  POEmail: string;
  Phone: string;
  PostalCode: string;
  Province: string;
  PublicName: string;
  ShopifyWebsite: string;
  PublicEmail: string;
  Terms: string
  Website: string;

  Priority: string;
  ShippingProfile: string;

  OnHold: number;
  DefaultWarehouse: string;
  ShipVia: string;
  PriceProfile: number;
  IsQualified: boolean;

  Bids: IManufacturerBid[];
  Qualifications: IResellerQualification[];
  Opportunities: IOpportunity[];
  Returns: IReturn[];
  SalesData: ISalesData;
  ActiveOrderDetails: IOrderDetailResult[];
  CompletedOrderDetails: IOrderDetailResult[];
}

export interface IResellerQualification {
  ManufacturerId: string;
  QualificationId: string;
  ManufacturerPublicName: string;
}

export interface ISalesStatistics {
  Day: number;
  Quantity: number;
  ExtendedPrice: number;
}
